import { render, staticRenderFns } from "./BuildingsNew.vue?vue&type=template&id=10dc6990&lang=pug&"
import script from "./BuildingsNew.vue?vue&type=script&lang=ts&"
export * from "./BuildingsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports